import React from 'react';
import BaseLayout from '../../components/layout/BaseLayout';
import styles from '../privacy/PrivacyPage.module.css';
import { FaTerminal } from 'react-icons/fa';
import TranslatedText from '../../components/TranslatedText/TranslatedText';
import { useTranslation } from '../../hooks/useTranslation';

const CookiesPage: React.FC = () => {
    const { t } = useTranslation();

    const handleManageSettings = () => {
        // Delete the consent cookie to make the cookie consent component visible again
        document.cookie = 'appotype_consent_given=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
        // Small delay to ensure the cookie is deleted before the component checks
        setTimeout(() => {
            window.location.reload();
        }, 100);
    };

    return (
        <BaseLayout>
            <div className={styles.container}>
                <header className={styles.header}>
                    <div className={styles.headerContent}>
                        <FaTerminal size={54} className={styles.terminalIcon} />
                        <div className={styles.headerText}>
                            <h1 className={styles.title}><TranslatedText textKey="cookies.title" /></h1>
                            <p className={styles.subtitle}>
                                <TranslatedText textKey="cookies.subtitle" />{' '}
                                <span 
                                    onClick={handleManageSettings}
                                    style={{
                                        color: 'var(--primary-color)',
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                        fontWeight: '500'
                                    }}
                                >
                                    <TranslatedText textKey="cookies.manageSettings" />
                                </span>
                            </p>
                        </div>
                    </div>
                </header>

                <div className={styles.content}>
                    <div className={styles.paragraph}>
                        <h2>{t("cookies.lastUpdated")}</h2>
                        <p>
                            {t("cookies.intro")}
                        </p>
                    </div>

                    <div className={styles.paragraph}>
                        <h2>{t("cookies.whatAre.title")}</h2>
                        <p>
                            {t("cookies.whatAre.content")}
                        </p>
                    </div>

                    <div className={styles.paragraph}>
                        <h2>{t("cookies.howWeUse.title")}</h2>
                        <p>
                            {t("cookies.howWeUse.content")}
                        </p>
                        <ul>
                            <li>{t("cookies.types.necessary")}</li>
                            <li>{t("cookies.types.analytics")}</li>
                            <li>{t("cookies.types.functional")}</li>
                        </ul>
                    </div>

                    <div className={styles.paragraph}>
                        <h2>{t("cookies.choices.title")}</h2>
                        <p>
                            {t("cookies.choices.content")}
                        </p>
                    </div>

                    <div className={styles.paragraph}>
                        <h2>{t("cookies.contact.title")}</h2>
                        <p>
                            {t("cookies.contact.content")}
                        </p>
                    </div>
                </div>
            </div>
        </BaseLayout>
    );
};

export default CookiesPage; 